// src/utils/osTarefa.js

// Padrão principal usado pelo backend ao gerar contas de OS de Tarefa:
// [OS-Tarefa #123] Descrição...
const OS_TAREFA_REGEX = /^\[OS-Tarefa #([^\]]+)\]\s*/i;

// Fallbacks defensivos para casos antigos ou variações futuras.
// Não dependemos deles no fluxo novo, mas ajudam a não quebrar registros legados.
const OS_TAREFA_ALT_REGEXES = [
  /^\[OS_TAREFA:([^\]]+)\]\s*/i,
  /^\[OS Tarefa #([^\]]+)\]\s*/i,
  /^\[Tarefa OS #([^\]]+)\]\s*/i,
];

export function parseOSTarefa(descricao = '') {
  const textoOriginal = String(descricao || '');

  const principal = textoOriginal.match(OS_TAREFA_REGEX);

  if (principal) {
    return {
      isTarefa: true,
      osId: principal[1],
      descricaoLimpa: textoOriginal.replace(OS_TAREFA_REGEX, '').trim(),
    };
  }

  for (const regex of OS_TAREFA_ALT_REGEXES) {
    const match = textoOriginal.match(regex);

    if (match) {
      return {
        isTarefa: true,
        osId: match[1],
        descricaoLimpa: textoOriginal.replace(regex, '').trim(),
      };
    }
  }

  return {
    isTarefa: false,
    osId: null,
    descricaoLimpa: textoOriginal,
  };
}